<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import BaseResultAnswer from '@/components/base/BaseResultAnswer.vue';

import { useSummariesStore } from '@/stores/summaries.store';
import type { Locales, SummaryFormStatProposalDto } from '@/services/types/api.types';
import { Constants } from '@/constants';

// STORE
const summariesStore = useSummariesStore();
const { formStats } = storeToRefs(summariesStore);

// PROPS
const props = defineProps<{
  languageEnabled: Locales[];
  formId: number;
}>();

// COMPUTED
const choices = computed(() => {
  const formStat = formStats?.value?.get(props.formId);
  switch (formStat?.type) {
    case Constants.Form.Type.Proposal: {
      const stats = formStat?.stats as unknown as SummaryFormStatProposalDto;
      return stats?.choices ? stats.choices : null;
    }
    default:
      return null;
  }
});
</script>
<template>
  <div class="form-multi-choice-question-results">
    <BaseResultAnswer
      v-for="choice in choices"
      :key="choice.id"
      :choice="choice"
      :language-enabled="props.languageEnabled"
      :question-has-choice-with-image="false"
    />
  </div>
</template>
